export default __webpack_public_path__ + "static/media/lets-spell.d52c3af1.png";